<div class="w-100 flex-row justify-center items-stretch text-center">
  <div class="w-30 flex-col pt-6">
    <!--display image, else brand display name-->
    @if (brandingData.brandingImageURL) {
      <img class="brand-image" src="{{brandImage}}" alt="brand-image" />
    } @else {
      <!--display company name if no branding exists-->
      <h2><strong>{{brandDisplayName?brandDisplayName:brandingData.companyName}}</strong></h2>
    }
    <p></p>
    <div class="flex-gt-sm-30 flex-lt-sm-100 pt-6">
      <mat-card class="mat-elevation-z6 box">
        <mat-card-content class="flex-col justify-end items-center text-center">
          <img [src]="cowImage" height="220" class="pt-2" alt="cowimage" />
          <span class="pt-2 pb-2"><strong>Unfortunately, that didn't work.</strong></span>
          <!--display company name if no branding exists-->
          <span class="pt-2 pb-6"><strong>If you feel this is an error, please contact {{brandDisplayName?brandDisplayName:brandingData.companyName}}.</strong></span>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>